import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "TipoMeritoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "TipoMeritoPage",
            ss: ss,
            auth: {},

            ajax: {
                "url": ss.indexTipoMerito(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'TipoMerito', name: 'TipoMerito', title: 'Tipo Merito' },
                
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],

            TipoMeritos: [],
            TipoMerito:{},

            rols: [],
            rol:{},
            
            isLoading: false,
            isLoadingFile: false,
            errorBag: {},
            password: {},
            
        };
    },
    methods: {

       /*  getRol() {
            this.ss.listRol().then(
                (result) => {
                    let response = result.data;
                    this.rols = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        }, */
        
        newTipoMerito() {
            this.TipoMerito = {};
            this.$refs['frm-TipoMerito'].show();
            // console.log("hhhhola")
        },
        showTipoMerito(id) {
            this.isLoading=true;
            this.ss.showTipoMerito(id).then(
                (result) => {
                    let response = result.data;
                    this.TipoMerito = response.data;
                    this.$refs['view-TipoMerito'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editTipoMerito() {
            this.$refs['frm-TipoMerito'].show();
            this.$refs['view-TipoMerito'].hide();
        },
        cancelTipoMerito() {
            if (this.TipoMerito.id) {
                this.$refs['view-TipoMerito'].show();
            }
            this.$refs['frm-TipoMerito'].hide();
        },
        saveTipoMerito() {
            this.ss.storeTipoMerito(this.TipoMerito).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-TipoMerito'].hide();
                    this.$refs['datatable-TipoMerito'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    console.log(error.response.data);
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteTipoMerito() {
            this.$swal({
                title: "¿Estás seguro que deseas eliminar?",
                text: "Esta acción es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyTipoMerito(this.TipoMerito)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-TipoMerito'].hide();
                                this.$refs['datatable-TipoMerito'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-TipoMerito').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showTipoMerito(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        
        var persona = JSON.parse(localStorage.getItem('persona'));
        this.auth = JSON.parse(localStorage.getItem("persona"));
        if (!persona) {
            this.$router.push('/Login');
        } else {
            // this.getUnidadAcademica();
            //this.getRol();
        }
    }
};
